import * as Modals from "../modalsTypes";

export const closePopup = () => ({
  type: Modals.CLOSE_POPUP,
});

export const removeLiquidity = (payload) => ({
  type: Modals.REMOVE_LIQUIDITY,
  payload,
});

export const tradeLend = (payload) => ({
  type: Modals.LB_LEND,
  payload,
});

export const tradeBorrow = (payload) => ({
  type: Modals.LB_BORROW,
  payload,
});

export const farmDW = (payload) => ({
  type: Modals.FARM_DW,
  payload,
});

export const connectWallet = (payload) => ({
  type: Modals.CONNECT_WALLET,
  payload,
});

export const max = (payload) => ({
  type: Modals.MAX,
  payload,
});

export const ApproveDeposit = (payload) => ({
  type: Modals.APPROVE_DEPOSIT,
  payload,
});

export const Approve = (payload) => ({
  type: Modals.APPROVE,
  payload,
});

export const farmClaim = (payload) => ({
  type: Modals.FARM_CLAIM,
  payload,
});

export const confirmWallet = (payload = {}) => ({
  type: Modals.WALLET_CONFIRM,
  payload,
});

export const confirm = (payload = {}) => ({
  type: Modals.CONFIRM,
  payload,
});

export const pageFarm = (payload = {}) => ({
  type: Modals.FARM_PAGE,
  payload,
});

export const pageFarmCohort = (payload) => ({
  type: Modals.FARM_PAGE_COHORT,
  payload,
});

export const swapSupply = () => ({
  type: Modals.SWAP_SUPPLY,
});

export const Buy = () => ({
  type: Modals.BUY,
});
